"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var _1 = require(".");
var Item = function (_a) {
    var name = _a.name, email = _a.email;
    return ((0, jsx_runtime_1.jsxs)(_1.Stack, __assign({ direction: "row", sx: { alignItems: 'center', padding: '10px' }, spacing: "1.2rem" }, { children: [(0, jsx_runtime_1.jsx)(_1.ThemedAvatar, __assign({ size: "medium" }, { children: name.charAt(0).toUpperCase() || email.charAt(0).toUpperCase() })), (0, jsx_runtime_1.jsx)(_1.Typography, __assign({ component: "p" }, { children: name || email }))] })));
};
var UserList = function (_a) {
    var data = _a.data;
    return ((0, jsx_runtime_1.jsx)(_1.Stack, __assign({ direction: { xs: 'column', md: 'row' }, sx: { flexWrap: 'wrap' } }, { children: data === null || data === void 0 ? void 0 : data.map(function (user, index) {
            return (0, jsx_runtime_1.jsx)(Item, { name: user.name, email: user.email }, index);
        }) })));
};
exports.UserList = UserList;
